import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyBfDAp3O6GGlUzvGRHqLVUbeHXhWhN_qRs',
  authDomain: 'promo-31469.firebaseapp.com',
  projectId: 'promo-31469',
  storageBucket: 'promo-31469.firebasestorage.app',
  messagingSenderId: '991909446722',
  appId: '1:991909446722:web:7b1b0f1610eba14935d9db',
  measurementId: 'G-3DYWZ5VM19',
}

const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
const auth = getAuth(app)

export { auth }
export default app
